import { FontSize } from "config/font";
import { TextInputWithLabel } from "web-apps/company/components/general/textInput/textInput.component";
import { normalizeNumber } from "web-apps/company/components/organizationalStructure/editModal.component";

export const NumberSettingInput: React.FC<{
  label: string;
  value: number | null | undefined;
  onChange: (v: number) => void;
}> = ({ label, value, onChange }) => (
  <TextInputWithLabel
    label={label}
    value={value?.toString() ?? ""}
    fontSize={FontSize.Standard}
    maxLength={6}
    onChange={(e: any) => {
      const val = normalizeNumber(e.target.value);
      onChange(val ?? 0);
    }}
  />
);
